import { addDays } from 'date-fns'
import React from 'react'
import useFormatDate from '../../../../hooks/useFormatDate'
import { humanReadableDateDiff } from '../../../../utils/Date'
import { DatePickerDrawerText } from '../styled'

export interface IDayCountTextProps {
  startDate: Date
  endDate: Date
  includeEnd?: boolean
}

const DayCountText = ({
                        startDate,
                        endDate,
                        includeEnd,
                      }: IDayCountTextProps) => {
  const formatDate = useFormatDate()

  return (
    <p style={{ margin: '0 0 16px', textAlign: 'center', width: '100%' }}>
      <DatePickerDrawerText>
        {`${startDate ? formatDate(startDate) : ''} - 
                  ${endDate ? formatDate(endDate) : ''} 
                  ${
          startDate && endDate
            ? `(${humanReadableDateDiff(
            startDate,
            addDays(endDate, includeEnd ? 1 : 0),
            )})`
            : ''
        }`}
      </DatePickerDrawerText>
    </p>
  )
}

export default DayCountText
